import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
const CategoryHeader = styled.div `
  background: ${THEME.COLOR_PRIMARY};
  border-color: ${THEME.COLOR_PRIMARY};
  color: ${THEME.COLOR_SECONDARY};
  padding: 0.5em 10px;
  font-size: 0.8em;
`;
const Category = (props) => (React.createElement("div", null,
    React.createElement(CategoryHeader, null, props.label),
    props.children));
export default Category;
//# sourceMappingURL=Category.js.map